(function () {
  if (window.__customTiltInit) return;
  window.__customTiltInit = true;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.PointerEvent) return;

  var MAX_TILT = 10;

  function initTilt(el) {
    var target = el.querySelector('[data-tilt-target]') || el.firstElementChild || el;
    var dragging = false;

    function apply(clientX, clientY) {
      var rect = el.getBoundingClientRect();
      var x = (clientX - rect.left) / rect.width;
      var y = (clientY - rect.top) / rect.height;
      var rotateY = (x - 0.5) * MAX_TILT * 2;
      var rotateX = (0.5 - y) * MAX_TILT * 2;
      target.style.transform =
        'rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg) scale3d(1.015,1.015,1.015)';
    }

    function reset() {
      target.classList.remove('is-tilting');
      target.style.transform = '';
    }

    // Desktop: mouse hover drives the tilt continuously.
    // Mobile/touch: tilt tracks the finger only while actively pressed
    // (no hover state exists on touch), so it behaves like a press-and-tilt card.
    el.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'mouse') {
        apply(e.clientX, e.clientY);
      } else if (dragging) {
        apply(e.clientX, e.clientY);
      }
    });

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') {
        dragging = true;
        target.classList.add('is-tilting');
      }
      apply(e.clientX, e.clientY);
    });

    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evtName) {
      el.addEventListener(evtName, function (e) {
        if (e.pointerType !== 'mouse') dragging = false;
        reset();
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-tilt]').forEach(initTilt);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
